var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFieldsDisabledState(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_31673_499106)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.60156 53.6443C4.49097 53.0283 5.39132 52.4123 6.3027 51.8299C8.29015 50.5419 10.3435 49.3323 12.4408 48.2123C14.538 47.0923 16.7231 46.0283 18.9301 45.0651C21.1372 44.1019 23.4651 43.2171 25.8039 42.4331C34.4856 39.5111 43.5638 37.9993 52.7058 37.9531",
    stroke: "#5E5F69",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8916 53.6453C24.3243 46.3907 38.3826 42.5329 52.7057 42.4453",
    stroke: "#5E5F69",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6865 53.6497C31.4686 49.2745 42.0251 46.9876 52.7061 46.9297",
    stroke: "#5E5F69",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7061 51.4219C46.8159 51.4516 40.9505 52.2037 35.2363 53.6619",
    stroke: "#5E5F69",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 37.9531H52.7059",
    stroke: "#5E5F69",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 42.4375H25.7161",
    stroke: "#5E5F69",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 46.9141H14.8675",
    stroke: "#5E5F69",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9806 36.85V36.458C38.9661 32.3612 40.5457 28.4258 43.3727 25.5156",
    stroke: "#5E5F69",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5356 23.6511C54.2757 20.8562 55.0892 17.1545 53.3525 15.383C51.6158 13.6116 47.9867 14.4413 45.2466 17.2362C42.5065 20.0311 41.693 23.7329 43.4297 25.5043C45.1664 27.2757 48.7955 26.446 51.5356 23.6511Z",
    stroke: "#5E5F69",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9805 36.85V36.458C38.995 32.3612 37.4154 28.4258 34.5884 25.5156",
    stroke: "#5E5F69",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5327 25.5076C36.2693 23.7361 35.4559 20.0344 32.7158 17.2395C29.9757 14.4446 26.3466 13.6149 24.6099 15.3863C22.8732 17.1577 23.6866 20.8595 26.4267 23.6544C29.1668 26.4493 32.796 27.279 34.5327 25.5076Z",
    stroke: "#5E5F69",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9803 16.673C41.4363 16.673 43.4273 13.4688 43.4273 9.51617C43.4273 5.56358 41.4363 2.35938 38.9803 2.35938C36.5242 2.35938 34.5332 5.56358 34.5332 9.51617C34.5332 13.4688 36.5242 16.673 38.9803 16.673Z",
    stroke: "#5E5F69",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9805 16.6797V37.5229",
    stroke: "#5E5F69",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.396 25.6406V37.9606",
    stroke: "#5E5F69",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6943 27.875V37.955",
    stroke: "#5E5F69",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6079 27.875V37.955",
    stroke: "#5E5F69",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.24707 29V37.96",
    stroke: "#5E5F69",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8433 31.2344V37.9544",
    stroke: "#5E5F69",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1177 31.2344V37.9544",
    stroke: "#5E5F69",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.09814 31.2344V37.9544",
    stroke: "#5E5F69",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5449 22.2734V37.9534",
    stroke: "#5E5F69",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_31673_499106"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFieldsDisabledState);
export default __webpack_public_path__ + "static/media/fieldsDisabledState.fcae19be7ee61db2e76330aa5f324bae.svg";
export { ForwardRef as ReactComponent };